import SystemParameter, {
  ISystemParameter,
  TSystemParameter
} from "../../model/systemparameter/SystemParameter";
import { IHttpService } from "../HttpService";
import {
  parseBooleanValueAsInteger,
  formatBooleanValueFromInteger
} from "../..";
import { DateService } from "../DateService";

export interface ISystemParameterService {
  getSystemParameters(): Promise<ISystemParameter[]>;
  createSystemParameter(systemParameter: ISystemParameter): Promise<any>;
  updateSystemParameter(systemParameter: ISystemParameter): void;
  deleteSystemParameter(id: number): Promise<any>;
  getNumber(property: string): Promise<number>;
}

const SystemParameterService = (httpService): ISystemParameterService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/system-parameters/";
  const _numberPath: string = "number";

  const SystemParameterListMapper = (json = []) => {
    return json.map((item: any) => {
      let systemParameter = SystemParameter(item);
      systemParameter.valueBoolean =
        item.valueBoolean !== undefined
          ? formatBooleanValueFromInteger(item.valueBoolean)
          : undefined;
      return systemParameter;
    });
  };
  let ParamsMapper = (data: TSystemParameter) => {
    return {
      ...data,
      valueDateTime: data.valueDateTime
        ? DateService().parseDateToTimestamp(data.valueDateTime)
        : undefined,
      valueBoolean:
        data.valueBoolean !== undefined
          ? parseBooleanValueAsInteger(data.valueBoolean)
          : undefined
    };
  };

  return {
    async getSystemParameters() {
      const path = _http.buildPath(_baseUrl);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return SystemParameterListMapper(responseJSON);
    },

    async deleteSystemParameter(systemParameterId: number) {
      const path = _http.buildPath(_baseUrl, systemParameterId.toString());
      const response = await _http.remove(path);
      return _http.toText(response);
    },

    async createSystemParameter(systemParameter: ISystemParameter) {
      const postPath = _http.buildPath(_baseUrl);
      const response = await _http.post(postPath, {
        params: ParamsMapper(systemParameter)
      });
      return _http.toText(response);
    },

    async updateSystemParameter(systemParameter: ISystemParameter) {
      const putPath = _http.buildPath(_baseUrl, systemParameter.id.toString());
      const response = await _http.put(putPath, {
        params: ParamsMapper(systemParameter)
      });
      return _http.toText(response);
    },

    async getNumber(property: string) {
      const path = _http.buildPath(_baseUrl, _numberPath);
      const response = await _http.get(path, {
        params: { property }
      });
      return _http.toJSON(response);
    }
  };
};

export default SystemParameterService;
